import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-destructive text-xs" }


export default /*@__PURE__*/_defineComponent({
  __name: 'InputError',
  props: {
    message: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.message), 1)
  ], 512)), [
    [_vShow, _ctx.message]
  ])
}
}

})